import * as tslib_1 from "tslib";
import { Component, Ref, Vue } from "vue-property-decorator";
import ListHeader from '../components/ListHeader.vue';
import ListAside from "../components/ListAside.vue";
import ListTable from "../components/ListTable.vue";
let TestPaperList = class TestPaperList extends Vue {
    constructor() {
        super(...arguments);
        this.libraryId = sessionStorage.getItem('examination_depot_library_id') || '0';
        this.keyword = '';
        this.initClientHeight = 0;
        this.treeData = [];
    }
    mounted() {
        this.initClientHeight = this.getClientHeight();
        this.$nextTick(() => {
            this.updateVisibleHeight();
            window.addEventListener("resize", this.updateVisibleHeight);
        });
    }
    beforeDestroy() {
        window.removeEventListener("resize", this.updateVisibleHeight);
    }
    updateVisibleHeight() {
        const el = this.mainArea;
        if (el) {
            const height = this.getClientHeight();
            el.style.height = `${height}px`;
        }
    }
    getClientHeight() {
        const el = this.mainArea;
        if (el) {
            const document = window.document.documentElement || window.document.body;
            const documentHeifht = document.clientHeight;
            const top = el.getBoundingClientRect().top;
            const offset = 20 + 10 + 1;
            const height = Math.floor(documentHeifht - top - offset);
            return height;
        }
        return 0;
    }
    handleTreeChange(treeData) {
        this.treeData = treeData;
    }
    refreshTree() {
        this.aside.refreshTree();
    }
    handleSearch(keyword) {
        this.keyword = keyword;
        setTimeout(this.table.updateListData, 0);
    }
};
tslib_1.__decorate([
    Ref()
], TestPaperList.prototype, "mainArea", void 0);
tslib_1.__decorate([
    Ref()
], TestPaperList.prototype, "aside", void 0);
tslib_1.__decorate([
    Ref()
], TestPaperList.prototype, "table", void 0);
TestPaperList = tslib_1.__decorate([
    Component({
        name: 'TestPaperList',
        components: {
            ListHeader,
            ListAside,
            ListTable,
        },
    })
], TestPaperList);
export default TestPaperList;
